






































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  AffiliationCreate,
  Role,
  StructuresTypesRole,
} from '@/client-axios';
import BackendService from '@/api/backendService';
import RolePermissionsTable from '@/components/RolePermissionsTable.vue';
import UserSelect from '@/components/Form/UserSelect.vue';

@Component({
  components: {
    RolePermissionsTable,
    UserSelect,
  },
})
export default class StructureAffiliationEditor extends Vue {
  @Prop({ required: true })
  readonly value: AffiliationCreate;

  @Prop({ required: true, type: Array })
  readonly roles: Role[];

  @Prop({ required: true, type: Number })
  readonly structureTypeId: number;

  @Watch('value.structureId')
  onStructureChange() {
    this.value.roleId = undefined as unknown as number;
  }

  created() {
    this.loadAllowedStructuresTypesRoles();
  }

  structureTypesRoles: StructuresTypesRole[] = [];

  loadAllowedStructuresTypesRoles() {
    return BackendService.usersApi.getStructuresTypesRoles()
      .then(({ data }) => {
        this.structureTypesRoles = data.items ?? [];
      });
  }

  get filteredRoles() {
    const allowedRoles = this.structureTypesRoles.filter((x) => x.structureTypeId === this.structureTypeId)
      .map((x) => x.roleId);
    return this.roles.filter((x) => x.name && allowedRoles.includes(x.id));
  }

  get selectedRole() {
    return this.roles.find((x) => x.id === this.value.roleId);
  }

  get isAdmin() {
    return this.$isInRole(this.$const.roles.ChiefAdministrator);
  }
}
